import classNames from "classnames";
import { formatGroupTimestamp, getGroupKindMeta } from "../../_constants/groups.const";
import type { Group } from "../../_types/groups.types";
import styles from "./GroupListItem.module.scss";

type GroupListItemProps = {
  group: Group;
  onClick: () => void;
};

export const GroupListItem = ({ group, onClick }: GroupListItemProps) => {
  const kindMeta = getGroupKindMeta(group.kind);

  return (
    <button type="button" className={styles["comp"]} onClick={onClick}>
      <div className={styles["comp__title-block"]}>
        <div className={styles["comp__name"]}>{group.name}</div>
        <div className={styles["comp__description"]}>
          {group.description ||
            (group.seatLimit != null
              ? `Seats ${group.seatOccupied}/${group.seatLimit}`
              : "No license")}
        </div>

      </div>

      <div className={styles["comp__kind"]}>
        <span
          className={classNames(
            styles["comp__badge"],
            styles[`comp__badge--${kindMeta.variant}`]
          )}
        >
          {kindMeta.label}
        </span>
      </div>

      <div className={styles["comp__members"]}>
        {group.memberCount} {group.memberCount === 1 ? "member" : "members"}
      </div>

      <time className={styles["comp__created-at"]} dateTime={new Date(group.createdAt).toISOString()}>
        {formatGroupTimestamp(group.createdAt)}
      </time>

      <time className={styles["comp__updated-at"]} dateTime={new Date(group.updatedAt).toISOString()}>
        {formatGroupTimestamp(group.updatedAt)}
      </time>
    </button>
  );
};
